module.exports = __webpack_public_path__ + "images/emoji/hotsprings.2c196d5a13aa50521140.png";